import Vue from 'vue';

import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(VueAxios, axios.create({
  withCredentials: true,
  baseURL: 'https://api.janine-und-johannes.de',
}));
